const checkIsKitPro = (kit) => (kit?.variants ?? []).some(v => v.sampling_type === 'stool_chemistry');
export default checkIsKitPro;
//# sourceMappingURL=checkIsKitPro.js.map